// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-translation-radio-group .fi-translation-heading {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 20px;
}
.fi-translation-radio-group .mat-mdc-radio-button {
  transition: 0.2s;
}
.fi-translation-radio-group .mat-mdc-radio-button.mat-mdc-radio-checked label {
  color: var(--branded-color);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-translation-radio-group/fi-translation-radio-group.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AAEY;EACI,2BAAA;EACA,gBAAA;AAAhB","sourcesContent":[".fi-translation-radio-group {\r\n    .fi-translation-heading {\r\n        font-weight: 700;\r\n        font-size: 16px;\r\n        margin-bottom: 20px;\r\n    }\r\n    .mat-mdc-radio-button {\r\n        transition: 0.2s;\r\n        &.mat-mdc-radio-checked {\r\n            label {\r\n                color: var(--branded-color);\r\n                font-weight: 700;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
